export const isProduction = () => window.location.host === 'portal.tpeteam.com';
const STAGING_HOSTS = ['portal.staging.tpeteam.com', 'portalaws.staging.tpeteam.com'];

export const isStaging = () => STAGING_HOSTS.includes(window.location.host);
export const isDevelopment = () => process.env.NODE_ENV === 'development'; // localhost
